// extracted by mini-css-extract-plugin
export default {"spinner":"_3mgIi","spin":"_lfx2Z"};